import ResponsiveImage from '@/v2/components/helpers/responsive-image'
import SectionWrapper from '@/v2/components/wrappers/section-wrapper'
import { CardType } from '@/v2/types/cards'
import { domAnimation, LazyMotion, m } from 'framer-motion'
import { useSearchParams } from 'next/navigation'

interface TwoCardsBannerSectionProps {
  title: string
  cards: CardType[]
}

const TwoCardsBannerSection: React.FC<TwoCardsBannerSectionProps> = props => {
  const { title, cards } = props

  const searchParams = useSearchParams()
  const activeTabId = Number(searchParams.get('tab')) || 1

  if (activeTabId !== 1) return

  return (
    <LazyMotion features={domAnimation}>
      <m.section className='text-center landing-pages-wr section-spacing bg-secondary-first'>
        <SectionWrapper className='md-mn:mb-[48px] mb-[24px] [&>h2]:leading-[30px] [&>h2]:md-mn:leading-[56px] [&>h2]:font-bold [&>h2]:text-secondary text-[24px] lg-mn:text-[36px]'>
          <h2>{title}</h2>

          <div className='flex items-start md-mn:flex-row flex-col lg-mn:gap-[100px] gap-[50px] mt-[48px]'>
            {cards?.map(card => {
              return (
                <div key={card.id} className='flex items-center  xl-min:gap-[24px] gap-[12px] xl-min:flex-row flex-col'>
                  <div>
                    <ResponsiveImage
                      src={card.image.src}
                      alt={card.image.alt}
                      className='md-mn:w-[330px] md-mn:h-[180px]'
                    />
                  </div>
                  <div className='xl:text-left xl-min:[&>h3]:text-[20px] [&>h3]:text-[18px] [&>h3]:font-[700] [&>h3]:leading-[32px] [&>h3]:text-tertiary-foreground [&>h3]:mb-[12px]'>
                    <h3>{card.title}</h3>
                    <p className='text-paragraph leading-[24px] text-[16px] font-[400]'>{card.description}</p>
                  </div>
                </div>
              )
            })}
          </div>
        </SectionWrapper>
      </m.section>
    </LazyMotion>
  )
}

export default TwoCardsBannerSection
